import { Container } from "unstated";

export class AppStateContainer extends Container {
  constructor() {
    super();

    //Load any async state here
    this.state = {
      token: this.loadObj("token"),
    };
  }
  
  persistObj(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj));
  }

  async setToken(token) {
    this.persistObj("token", token);
    await this.setState({ token });
  }

  loadObj(key) {
    return JSON.parse(localStorage.getItem(key));
  }



  async logout() {
    await this.setToken(null);
  }
}

const appState = new AppStateContainer();

window.APP_STATE = appState;

export default appState;
